<wtf-dialogcontent [size]="'auto'" dialogTitle="{{ dialogTitle | translate }}" (closeModal)="dialogRef.close()"
    [action]="action">
    <div class="page-layout blank mat-white-bg">
        <div class="content" fxLayout="column">
            <div class="pb-16">
                <div class="py-4" fxLayout="row" fxLayoutAlign="space-between center">
                    <span class="h4 m-1">{{
                        "Total Envíos Fallidos" | translate
                        }}</span>
                    <span class="h4">{{ campaignData.totalFailed }}</span>
                </div>
                <div class="mt-12 py-4 grey-100-bg">
                    <mat-progress-bar class="orange-progress-bar" *ngIf="loading"
                        mode="indeterminate"></mat-progress-bar>
                    <div *ngIf="!loading" class="position-relative h-200 pb-16">
                        <table class="simple">
                            <thead>
                                <tr>
                                    <th>{{ "Descripción" | translate }}</th>
                                    <th>{{ "Cantidad" | translate }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let error of errorsData">
                                    <td>
                                        {{ error.codeError | translate }}
                                    </td>
                                    <td>
                                        {{ error.count }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</wtf-dialogcontent>